var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "app-tabbar" },
    _vm._l(_vm.tabs, function (item) {
      return _c(
        "div",
        {
          key: item.key,
          staticClass: "tab-item",
          class: { on: item.key === _vm.currentKey },
          on: {
            click: function ($event) {
              return _vm.handleGo(item)
            },
          },
        },
        [
          _c("span", {
            staticClass: "tab-ico",
            domProps: { innerHTML: _vm._s(item.icon) },
          }),
          _c("span", { staticClass: "tab-txt" }, [_vm._v(_vm._s(item.text))]),
          item.dot && item.key !== _vm.currentKey
            ? _c("i", { staticClass: "tab-dot" })
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }